import { MutationTree } from 'vuex';
import { EQUIPEMENT } from './mutation-types';
import { EquipementState } from './state';
import { InterventionNonPreventive } from '@/models/InterventionNonPreventive';
import { SortType } from '@/models/SortType';
import { TableHeader } from '@/models/TableHeader';
import dayjs from 'dayjs';
import { InterventionPreventive } from '@/models/InterventionPreventive';
import { CaracteristiqueArticle } from '@/models/CaracteristiqueArticle';
import { Operation } from '@/models/Operation';
import { Devis, EtatDevis } from '@/models/Devis';
import { DemandeIntervention } from '@/models/DemandeIntervention';
import { initialState as resetState } from '@/modules/DemandeIntervention/store/state';
import { DocumentReglementaire } from '@/models/DocumentReglementaire';
import { AnalyseDeRisqueDTO } from '@/models/AnalyseDeRisqueDTO';
import { PriseEnChargeDTO } from '@/models/PriseEnChargeDTO';
import { TypeDocumentReglementaire } from '@/models/TypeDocumentReglementaire';

export const mutations: MutationTree<EquipementState> = {
    [EQUIPEMENT.SET_ACTIVE_TAB](state, tabId: string) {
        state.activeTabId = tabId;
    },
    [EQUIPEMENT.SET_DETAILS_EQUIPEMENT](state, detailsEquipement: any) {
        state.detailsEquipement = detailsEquipement;
    },
    [EQUIPEMENT.SET_LOADING](state, isLoading: boolean) {
        state.isLoading = isLoading;
    },
    [EQUIPEMENT.SET_ERROR](state, error: boolean) {
        state.error = error;
    },

    //Dashboard
    [EQUIPEMENT.SET_NON_PREVENTIVE_STATS](state, stats: any) {
        state.nonPreventiveStats = stats;
    },
    [EQUIPEMENT.SET_PREVENTIVE_STATS_CHART](state, stats: any) {
        state.preventiveStatsChart = stats;
    },
    [EQUIPEMENT.SET_PREVENTIVE_STATS_CIRCLE](state, stats: any) {
        state.preventiveStatsCircle = stats;
    },
    [EQUIPEMENT.SET_DEVIS_STATS](state, stats: any) {
        state.devisStats = stats;
    },
    [EQUIPEMENT.SET_DEMANDES_INTERVENTION_STATS](state, stats: any) {
        state.demandesInterventionStats = stats;
    },
    [EQUIPEMENT.SET_NON_PREVENTIVE_STATS_LOADING](state, isLoading: boolean) {
        state.isNonPreventiveStatsLoading = isLoading;
    },
    [EQUIPEMENT.SET_PREVENTIVE_STATS_CIRCLE_LOADING](state, isLoading: boolean) {
        state.isPreventiveStatsCircleLoading = isLoading;
    },
    [EQUIPEMENT.SET_PREVENTIVE_STATS_CHART_LOADING](state, isLoading: boolean) {
        state.isPreventiveStatsChartLoading = isLoading;
    },
    [EQUIPEMENT.SET_DEVIS_STATS_LOADING](state, isLoading: boolean) {
        state.isDevisStatsLoading = isLoading;
    },
    [EQUIPEMENT.SET_DEMANDES_INTERVENTION_STATS_LOADING](state, isLoading: boolean) {
        state.isDemandesInterventionStatsLoading = isLoading;
    },

    //Historique demande interventions
    [EQUIPEMENT.HISTORIQUE_DEMANDE_INTERVENTION_SET_ITEMS](state, items: DemandeIntervention[]) {
        state.historiqueDemandesInterventions.demandesIntervention = items;
    },
    [EQUIPEMENT.HISTORIQUE_DEMANDE_INTERVENTION_RESET_ITEMS](state) {
        state.historiqueDemandesInterventions.demandesIntervention = [];
        state.historiqueDemandesInterventions.page = 0;
        state.historiqueDemandesInterventions.count = 0;
    },
    // [EQUIPEMENT.HISTORIQUE_DEMANDE_INTERVENTION_REMOVE_ITEM](state, id: number) {
    //     state.historiqueDemandesInterventions = state.historiqueDemandesInterventions.filter(item => item.id !== id);
    //     state.historiqueDemandesInterventions.count = Math.max(0, state.historiqueDemandesInterventions.count - 1);
    // },
    [EQUIPEMENT.HISTORIQUE_DEMANDE_INTERVENTION_ADD_ITEMS](state, items: DemandeIntervention[]) {
        state.historiqueDemandesInterventions.demandesIntervention = [
            ...state.historiqueDemandesInterventions.demandesIntervention,
            ...items,
        ];
    },
    [EQUIPEMENT.HISTORIQUE_DEMANDE_INTERVENTION_SET_PAGE](state, page: number) {
        state.historiqueDemandesInterventions.page = page;
    },
    [EQUIPEMENT.HISTORIQUE_DEMANDE_INTERVENTION_SET_COUNT](state, count: number) {
        state.historiqueDemandesInterventions.count = count;
    },
    [EQUIPEMENT.HISTORIQUE_DEMANDE_INTERVENTION_SET_NB_OF_PAGES](state, pages: number) {
        state.historiqueDemandesInterventions.nbOfPages = pages;
    },

    [EQUIPEMENT.HISTORIQUE_DEMANDE_INTERVENTION_SET_SCROLL](state, scroll: number) {
        state.historiqueDemandesInterventions.scroll = scroll;
    },
    [EQUIPEMENT.HISTORIQUE_DEMANDE_INTERVENTION_SET_SORT](
        state,
        sort: {
            sortData: string;
            sortStatus: SortType;
        }
    ) {
        state.historiqueDemandesInterventions.tableHeader = state.historiqueDemandesInterventions.tableHeader.reduce(
            (newTable, headerItem) => {
                if (headerItem.sortData !== sort.sortData) {
                    if (headerItem.sortStatus !== SortType.INACTIVE) headerItem.sortStatus = SortType.NONE;
                } else headerItem.sortStatus = sort.sortStatus;
                return [...newTable, headerItem];
            },
            [] as TableHeader[]
        );
        state.historiqueDemandesInterventions.sort = sort;
    },

    [EQUIPEMENT.HISTORIQUE_DEMANDE_INTERVENTION_ADD_FILTER_STATUS](state, status: string) {
        state.historiqueDemandesInterventions.filter.statusList = [
            ...state.historiqueDemandesInterventions.filter.statusList,
            status,
        ];
    },
    [EQUIPEMENT.HISTORIQUE_DEMANDE_INTERVENTION_RESET_FILTER](state) {
        state.historiqueDemandesInterventions.filter.statusList = [];
        state.historiqueDemandesInterventions.filter.demandeInterventionId = '';
        state.historiqueDemandesInterventions.filter.createdDateFrom = dayjs().add(-1, 'y').format('YYYY-MM-DD');
        state.historiqueDemandesInterventions.filter.createdDateTo = dayjs().format('YYYY-MM-DD');
    },
    [EQUIPEMENT.HISTORIQUE_DEMANDE_INTERVENTION_REMOVE_FILTER_STATUS](state, status: string) {
        state.historiqueDemandesInterventions.filter.statusList =
            state.historiqueDemandesInterventions.filter.statusList.filter(x => x !== status);
    },
    [EQUIPEMENT.HISTORIQUE_DEMANDE_INTERVENTION_SET_FILTER_STATUS](state, statusList: Array<string>) {
        state.historiqueDemandesInterventions.filter.statusList = statusList;
    },
    [EQUIPEMENT.HISTORIQUE_DEMANDE_INTERVENTION_SET_FILTER_DEMANDE_INTERVENTION_ID](state, id: string) {
        state.historiqueDemandesInterventions.filter.demandeInterventionId = id;
    },

    [EQUIPEMENT.HISTORIQUE_DEMANDE_INTERVENTION_SET_FILTER_CREATED_DATE_FROM](state, value: string) {
        state.historiqueDemandesInterventions.filter.createdDateFrom = value;
    },
    [EQUIPEMENT.HISTORIQUE_DEMANDE_INTERVENTION_SET_FILTER_CREATED_DATE_TO](state, value: string) {
        state.historiqueDemandesInterventions.filter.createdDateTo = value;
    },
    [EQUIPEMENT.HISTORIQUE_DEMANDE_INTERVENTION_SET_IS_LOADING](state, isLoading: boolean) {
        state.historiqueDemandesInterventions.isLoading = isLoading;
    },
    [EQUIPEMENT.HISTORIQUE_DEMANDE_INTERVENTION_SET_ERROR](state, error: Error) {
        state.historiqueDemandesInterventions.error = error;
    },
    [EQUIPEMENT.HISTORIQUE_DEMANDE_INTERVENTION_CLEAR_ALL](state) {
        Object.assign(state, resetState);
    },

    [EQUIPEMENT.HISTORIQUE_DEMANDE_INTERVENTION_SET_EXPORT_XLS_IS_LOADING](state, isLoading: boolean) {
        state.historiqueDemandesInterventions.isExportXlsLoading = isLoading;
    },
    // Historique Travaux
    [EQUIPEMENT.HISTORIQUE_TRAVAUX_SET_ITEMS](state, items: InterventionNonPreventive[]) {
        state.historiqueTravaux.items = items;
    },
    [EQUIPEMENT.HISTORIQUE_TRAVAUX_ADD_ITEMS](state, items: InterventionNonPreventive[]) {
        state.historiqueTravaux.items = [...state.historiqueTravaux.items, ...items];
    },
    [EQUIPEMENT.HISTORIQUE_TRAVAUX_SET_PAGE](state, page: number) {
        state.historiqueTravaux.page = page;
    },
    [EQUIPEMENT.HISTORIQUE_TRAVAUX_SET_NB_OF_PAGES](state, pages: number) {
        state.historiqueTravaux.nbOfPages = pages;
    },
    [EQUIPEMENT.HISTORIQUE_TRAVAUX_SET_COUNT](state, count: number) {
        state.historiqueTravaux.count = count;
    },
    [EQUIPEMENT.HISTORIQUE_TRAVAUX_SET_SORT](
        state,
        sort: {
            sortData: string;
            sortStatus: SortType;
        }
    ) {
        state.historiqueTravaux.tableHeader = state.historiqueTravaux.tableHeader.reduce((newTable, headerItem) => {
            if (headerItem.sortData !== sort.sortData) {
                if (headerItem.sortStatus !== SortType.INACTIVE) headerItem.sortStatus = SortType.NONE;
            } else headerItem.sortStatus = sort.sortStatus;
            return [...newTable, headerItem];
        }, [] as TableHeader[]);
        state.historiqueTravaux.sort = sort;
    },
    [EQUIPEMENT.HISTORIQUE_TRAVAUX_SET_IS_LOADING](state, isLoading: boolean) {
        state.historiqueTravaux.isLoading = isLoading;
    },

    [EQUIPEMENT.HISTORIQUE_TRAVAUX_ADD_FILTER_STATUS](state, status: string) {
        state.historiqueTravaux.filter.statusList = [...state.historiqueTravaux.filter.statusList, status];
    },
    [EQUIPEMENT.HISTORIQUE_TRAVAUX_REMOVE_FILTER_STATUS](state, status: string) {
        state.historiqueTravaux.filter.statusList = state.historiqueTravaux.filter.statusList.filter(x => x !== status);
    },
    [EQUIPEMENT.HISTORIQUE_TRAVAUX_SET_FILTER_STATUS](state, statusList: string[]) {
        state.historiqueTravaux.filter.statusList = statusList;
    },
    [EQUIPEMENT.HISTORIQUE_TRAVAUX_SET_FILTER_INTERVENTION_ID](state, id: string) {
        state.historiqueTravaux.filter.interventionId = id;
    },
    [EQUIPEMENT.HISTORIQUE_TRAVAUX_SET_FILTER_PREDICTED_DATE_FROM](state, value: string) {
        state.historiqueTravaux.filter.predictedDateFrom = value;
    },
    [EQUIPEMENT.HISTORIQUE_TRAVAUX_SET_FILTER_PREDICTED_DATE_TO](state, value: string) {
        state.historiqueTravaux.filter.predictedDateTo = value;
    },
    [EQUIPEMENT.HISTORIQUE_TRAVAUX_RESET_FILTER](state) {
        state.historiqueTravaux.filter.statusList = [];
        state.historiqueTravaux.filter.interventionId = '';
        state.historiqueTravaux.filter.predictedDateFrom = dayjs().add(-1, 'y').format('YYYY-MM-DD');
        state.historiqueTravaux.filter.predictedDateTo = dayjs().format('YYYY-MM-DD');
    },
    [EQUIPEMENT.HISTORIQUE_TRAVAUX_SET_EXPORT_XLS_IS_LOADING](state, isLoading: boolean) {
        state.historiqueTravaux.exportXlsIsLoading = isLoading;
    },

    //Intrerventions Préventives

    [EQUIPEMENT.INTERVENTIONS_PREVENTIVES_SET_ITEMS](state, items: InterventionPreventive[]) {
        state.interventionsPreventives.items = items;
    },
    [EQUIPEMENT.INTERVENTIONS_PREVENTIVES_ADD_ITEMS](state, items: InterventionPreventive[]) {
        state.interventionsPreventives.items = [...state.interventionsPreventives.items, ...items];
    },
    [EQUIPEMENT.INTERVENTIONS_PREVENTIVES_SET_PAGE](state, page: number) {
        state.interventionsPreventives.page = page;
    },
    [EQUIPEMENT.INTERVENTIONS_PREVENTIVES_SET_NB_OF_PAGES](state, pages: number) {
        state.interventionsPreventives.nbOfPages = pages;
    },
    [EQUIPEMENT.INTERVENTIONS_PREVENTIVES_SET_COUNT](state, count: number) {
        state.interventionsPreventives.count = count;
    },
    [EQUIPEMENT.INTERVENTIONS_PREVENTIVES_SET_SORT](
        state,
        sort: {
            sortData: string;
            sortStatus: SortType;
        }
    ) {
        state.interventionsPreventives.tableHeader = state.interventionsPreventives.tableHeader.reduce(
            (newTable, headerItem) => {
                if (headerItem.sortData !== sort.sortData) {
                    if (headerItem.sortStatus !== SortType.INACTIVE) headerItem.sortStatus = SortType.NONE;
                } else headerItem.sortStatus = sort.sortStatus;
                return [...newTable, headerItem];
            },
            [] as TableHeader[]
        );
        state.interventionsPreventives.sort = sort;
    },
    [EQUIPEMENT.INTERVENTIONS_PREVENTIVES_SET_IS_LOADING](state, isLoading: boolean) {
        state.interventionsPreventives.isLoading = isLoading;
    },

    [EQUIPEMENT.INTERVENTIONS_PREVENTIVES_ADD_FILTER_STATUS](state, status: string) {
        state.interventionsPreventives.filter.statusList = [
            ...state.interventionsPreventives.filter.statusList,
            status,
        ];
    },
    [EQUIPEMENT.INTERVENTIONS_PREVENTIVES_REMOVE_FILTER_STATUS](state, status: string) {
        state.interventionsPreventives.filter.statusList = state.interventionsPreventives.filter.statusList.filter(
            x => x !== status
        );
    },
    [EQUIPEMENT.INTERVENTIONS_PREVENTIVES_SET_FILTER_STATUS](state, statusList: string[]) {
        state.interventionsPreventives.filter.statusList = statusList;
    },
    [EQUIPEMENT.INTERVENTIONS_PREVENTIVES_SET_FILTER_INTERVENTION_ID](state, id: string) {
        state.interventionsPreventives.filter.interventionId = id;
    },
    [EQUIPEMENT.INTERVENTIONS_PREVENTIVES_SET_FILTER_PREDICTED_DATE_FROM](state, value: string) {
        state.interventionsPreventives.filter.predictedDateFrom = value;
    },
    [EQUIPEMENT.INTERVENTIONS_PREVENTIVES_SET_FILTER_PREDICTED_DATE_TO](state, value: string) {
        state.interventionsPreventives.filter.predictedDateTo = value;
    },
    [EQUIPEMENT.INTERVENTIONS_PREVENTIVES_RESET_FILTER](state) {
        state.interventionsPreventives.filter.statusList = [];
        state.interventionsPreventives.filter.interventionId = '';
        state.interventionsPreventives.filter.predictedDateFrom = dayjs().add(-1, 'y').format('YYYY-MM-DD');
        state.interventionsPreventives.filter.predictedDateTo = dayjs().format('YYYY-MM-DD');
    },
    [EQUIPEMENT.INTERVENTIONS_PREVENTIVES_SET_EXPORT_XLS_IS_LOADING](state, isLoading: boolean) {
        state.interventionsPreventives.exportXlsIsLoading = isLoading;
    },

    [EQUIPEMENT.SET_CARACTERISTIQUES_EQUIPEMENT](state, caracteristiques: CaracteristiqueArticle[]) {
        state.caracteristiquesArticle = caracteristiques;
    },
    [EQUIPEMENT.SET_IS_CARACTERISTIQUES_LOADING](state, isLoading: boolean) {
        state.isCaracteristiquesLoading = isLoading;
    },
    [EQUIPEMENT.SET_OPERATION_MAINTENANCE](state, operations: Operation[]) {
        state.operations = operations;
    },
    [EQUIPEMENT.SET_IS_OPERATION_MAINTENANCE_LOADING](state, isLoading: boolean) {
        state.isOperationMaintenanceLoading = isLoading;
    },
    //HISTORIQUE-DEVIS
    [EQUIPEMENT.DEVIS_SET_ITEMS](state, items: Devis[]) {
        state.historiqueDevis.devis = items;
    },
    [EQUIPEMENT.DEVIS_RESET_ITEMS](state) {
        state.historiqueDevis.page = 0;
        state.historiqueDevis.devis = [];
        state.historiqueDevis.count = 0;
    },
    [EQUIPEMENT.DEVIS_ADD_ITEMS](state, items: Devis[]) {
        state.historiqueDevis.devis = [...state.historiqueDevis.devis, ...items];
    },
    [EQUIPEMENT.DEVIS_SET_PAGE](state, page: number) {
        state.historiqueDevis.page = page;
    },
    [EQUIPEMENT.DEVIS_SET_COUNT](state, count: number) {
        state.historiqueDevis.count = count;
    },
    [EQUIPEMENT.DEVIS_SET_NB_OF_PAGES](state, pages: number) {
        state.historiqueDevis.nbOfPages = pages;
    },
    [EQUIPEMENT.DEVIS_SET_SCROLL](state, scroll: number) {
        state.historiqueDevis.scroll = scroll;
    },
    [EQUIPEMENT.DEVIS_SET_SORT](
        state,
        sort: {
            sortData: string;
            sortStatus: SortType;
        }
    ) {
        state.historiqueDevis.tableHeader = state.historiqueDevis.tableHeader.reduce((newTable, headerItem) => {
            if (headerItem.sortData !== sort.sortData) {
                if (headerItem.sortStatus !== SortType.INACTIVE) headerItem.sortStatus = SortType.NONE;
            } else headerItem.sortStatus = sort.sortStatus;
            return [...newTable, headerItem];
        }, [] as TableHeader[]);
        state.historiqueDevis.sort = sort;
    },
    [EQUIPEMENT.DEVIS_ADD_FILTER_STATUS](state, status: string) {
        state.historiqueDevis.filter.filterStatus = [...state.historiqueDevis.filter.filterStatus, status];
    },
    [EQUIPEMENT.DEVIS_REMOVE_FILTER_STATUS](state, status: string) {
        state.historiqueDevis.filter.filterStatus = state.historiqueDevis.filter.filterStatus.filter(x => x !== status);
    },
    [EQUIPEMENT.DEVIS_SET_FILTER_STATUS](state, statusList: string[]) {
        state.historiqueDevis.filter.filterStatus = statusList;
    },
    [EQUIPEMENT.DEVIS_SET_FILTER_DEVIS_ID](state, id: string) {
        state.historiqueDevis.filter.filterDevisId = id;
    },
    [EQUIPEMENT.DEVIS_SET_FILTER_DEVIS_NUMERO_COMMANDE](state, id: string) {
        state.historiqueDevis.filter.filterNumero = id;
    },
    [EQUIPEMENT.DEVIS_SET_FILTER_DEVIS_NUM_FACTURE](state, id: string) {
        state.historiqueDevis.filter.filterNumFactures = id;
    },
    [EQUIPEMENT.DEVIS_SET_IS_LOADING](state, isLoading: boolean) {
        state.historiqueDevis.isLoading = isLoading;
    },
    [EQUIPEMENT.DEVIS_SET_ERROR](state, error: Error) {
        state.historiqueDevis.error = error;
    },
    [EQUIPEMENT.DEVIS_RESET_FILTER](state) {
        state.historiqueDevis.filter.filterStatus = Object.values(EtatDevis);
        state.historiqueDevis.filter.filterDevisId = '';
        state.historiqueDevis.filter.filterNumero = '';
        state.historiqueDevis.filter.filterNumFactures = '';
    },

    [EQUIPEMENT.DEVIS_SET_EXPORT_XLS_IS_LOADING](state, isLoading: boolean) {
        state.historiqueDevis.isExportXlsLoading = isLoading;
    },

    //DOCUMENT Règlementaires
    [EQUIPEMENT.DOCUMENT_REGLEMENTAIRE_SET_ITEMS](state, items: DocumentReglementaire[]) {
        state.documentReglementaire.documentReglementaire = items;
    },
    [EQUIPEMENT.DOCUMENT_REGLEMENTAIRE_ADD_ITEMS](state, items: DocumentReglementaire[]) {
        state.documentReglementaire.documentReglementaire = [
            ...state.documentReglementaire.documentReglementaire,
            ...items,
        ];
    },
    [EQUIPEMENT.DOCUMENT_REGLEMENTAIRE_SET_ADR_ITEMS](state, items: AnalyseDeRisqueDTO[]) {
        state.documentReglementaire.adr = items;
    },
    [EQUIPEMENT.DOCUMENT_REGLEMENTAIRE_ADD_ADR_ITEMS](state, items: AnalyseDeRisqueDTO[]) {
        state.documentReglementaire.adr = [...state.documentReglementaire.adr, ...items];
    },
    [EQUIPEMENT.DOCUMENT_REGLEMENTAIRE_SET_PEC_ITEMS](state, items: PriseEnChargeDTO[]) {
        state.documentReglementaire.prisesEnCharge = items;
    },
    [EQUIPEMENT.DOCUMENT_REGLEMENTAIRE_RESET_ITEMS](state) {
        state.documentReglementaire.documentReglementaire = [];
        state.documentReglementaire.adr = [];
        state.documentReglementaire.prisesEnCharge = [];
        state.documentReglementaire.page = 0;
        state.documentReglementaire.count = 0;
    },
    [EQUIPEMENT.DOCUMENT_REGLEMENTAIRE_SET_FILTER_DOCUMENT_TYPE](
        state,
        documentTypeList: Array<TypeDocumentReglementaire>
    ) {
        state.documentReglementaire.filter.filterDocumentType = documentTypeList;
    },

    [EQUIPEMENT.DOCUMENT_REGLEMENTAIRE_SET_PAGE](state, page: number) {
        state.documentReglementaire.page = page;
    },
    [EQUIPEMENT.DOCUMENT_REGLEMENTAIRE_SET_NB_OF_PAGES](state, pages: number) {
        state.documentReglementaire.nbOfPages = pages;
    },
    [EQUIPEMENT.DOCUMENT_REGLEMENTAIRE_SET_SCROLL](state, scroll: number) {
        state.documentReglementaire.scroll = scroll;
    },
    [EQUIPEMENT.DOCUMENT_REGLEMENTAIRE_SET_COUNT](state, count: number) {
        state.documentReglementaire.count = count;
    },
    [EQUIPEMENT.DOCUMENT_REGLEMENTAIRE_SET_SORT](
        state,
        sort: {
            sortData: string;
            sortStatus: SortType;
        }
    ) {
        state.documentReglementaire.tableHeader = state.documentReglementaire.tableHeader.reduce(
            (newTable, headerItem) => {
                if (headerItem.sortData !== sort.sortData) {
                    if (headerItem.sortStatus !== SortType.INACTIVE) headerItem.sortStatus = SortType.NONE;
                } else headerItem.sortStatus = sort.sortStatus;
                return [...newTable, headerItem];
            },
            [] as TableHeader[]
        );
        state.documentReglementaire.sort = sort;
    },
    [EQUIPEMENT.DOCUMENT_REGLEMENTAIRE_SET_SORT_ADR](
        state,
        sort: {
            sortData: string;
            sortStatus: SortType;
        }
    ) {
        state.documentReglementaire.tableAdrHeader = state.documentReglementaire.tableAdrHeader.reduce(
            (newTable, headerItem) => {
                if (headerItem.sortData !== sort.sortData) {
                    if (headerItem.sortStatus !== SortType.INACTIVE) headerItem.sortStatus = SortType.NONE;
                } else headerItem.sortStatus = sort.sortStatus;
                return [...newTable, headerItem];
            },
            [] as TableHeader[]
        );
        state.documentReglementaire.sort = sort;
    },
    [EQUIPEMENT.DOCUMENT_REGLEMENTAIRE_RESET](state) {
        Object.assign(state, resetState);
    },
    [EQUIPEMENT.DOCUMENT_REGLEMENTAIRE_SET_IS_LOADING](state, isLoading: boolean) {
        state.documentReglementaire.isLoading = isLoading;
    },
    [EQUIPEMENT.DOCUMENT_REGLEMENTAIRE_SET_ZIP_IS_LOADING](state, isLoading: boolean) {
        state.documentReglementaire.isZipLoading = isLoading;
    },
    [EQUIPEMENT.DOCUMENT_REGLEMENTAIRE_SET_LIST_TYPES_IS_LOADING](state, listTypesIsLoading: boolean) {
        state.documentReglementaire.listTypesIsLoading = listTypesIsLoading;
    },
    [EQUIPEMENT.DOCUMENT_REGLEMENTAIRE_SET_ERROR](state, error: Error | undefined) {
        state.documentReglementaire.error = error;
    },
    [EQUIPEMENT.DOCUMENT_REGLEMENTAIRE_SET_COUNT_FOR_MODAL](state, nombreDocuments: number) {
        state.documentReglementaire.nombreDocumentModal = nombreDocuments;
    },
    [EQUIPEMENT.DOCUMENTS_REGLEMENTAIRES_SET_TYPES](state, typesDocuments: TypeDocumentReglementaire[]) {
        state.documentReglementaire.typesDocumentsReglementaires = typesDocuments;
    },
};
